module.exports = __webpack_public_path__ + "static/media/memory.18645488.jpg";